export const MAX_CHARACTERS = 150
export const AVERAGE_LETTER_WIDTH = 5
